module.exports = __webpack_public_path__ + "img/user-help.10b750c5.png";